import { React, Suspense, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { checkAdminAccess } from './features/auth/authSlice';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
/// Layout
import Nav from "./jsx/layouts/nav";
import Footer from "./jsx/layouts/Footer";
import ScrollToTop from "./jsx/layouts/ScrollToTop";
// Import Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import "./vendor/bootstrap-select/dist/css/bootstrap-select.min.css";
import "./css/style.css";

// ROUTES
import LoginEmail from './pages/auth/LoginEmail';
import SuperAdminHome from './pages/SuperAdminHome';
import Error403 from './jsx/pages/Error403';
import UsersListPage from './features/user/pages/UsersListPage';
import UsersActivePage from './features/user/pages/UsersActivePage';
import UsersCreatePage from './features/user/pages/UsersCreatePage';
import UsersEditPage from './features/user/pages/UsersEditPage';
import UsersAssignBusinessPage from './features/user/pages/UsersAssignBusinessPage';
import UsersDemoPage from './features/user/pages/UsersDemoPage';
import DemoManagement from './features/demo/pages/DemoManagement';
import BusinessManagement from './features/business/pages/BusinessManagement';
import BusinessListPage from './features/business/pages/BusinessListPage';
import BusinessActivePage from './features/business/pages/BusinessActivePage';
import BusinessCreatePage from './features/business/pages/BusinessCreatePage';
import BusinessEditPage from './features/business/pages/BusinessEditPage';
import BusinessAssignUsersPage from './features/business/pages/BusinessAssignUsersPage';
import DigitalCardsManagement from './features/digitalcards/pages/DigitalCardsManagement';
import DigitalCardsListPage from './features/digitalcards/pages/DigitalCardsListPage';
import DigitalCardsActivePage from './features/digitalcards/pages/DigitalCardsActivePage';
import DigitalCardsCreatePage from './features/digitalcards/pages/DigitalCardsCreatePage';
import DigitalCardsEditPage from './features/digitalcards/pages/DigitalCardsEditPage';
import StatisticsDashboardPage from './features/statistics/pages/StatisticsDashboardPage';
import MeetingStatisticsPage from './features/statistics/pages/MeetingStatisticsPage';
import BeetinqTeamManagementPage from './features/beetinqteam/pages/BeetinqTeamManagementPage';
import DemoRequestsPage from './features/demo-requests/pages/DemoRequestsPage';

function App() {
  const navigate = useNavigate();
  const isAuthenticated = useSelector((state) => state.auth.user !== null);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const adminAccess = useSelector((state) => state.auth.adminAccess);
  const adminCheckLoading = useSelector((state) => state.auth.adminCheckLoading);

  useEffect(() => {
    if (!isAuthenticated) {
      //navigate('/login')
    }
  }, [isAuthenticated, navigate]);

  useEffect(() => {
    if (isAuthenticated && user?.uid && adminAccess === null && !adminCheckLoading) {
      dispatch(checkAdminAccess(user.uid));
    }
  }, [isAuthenticated, user?.uid, adminAccess, adminCheckLoading, dispatch]);

  if (isAuthenticated) {
    if (adminCheckLoading || adminAccess === null) {
      return (
        <div id="preloader">
          <div className="sk-three-bounce">
            <div className="sk-child sk-bounce1"></div>
            <div className="sk-child sk-bounce2"></div>
            <div className="sk-child sk-bounce3"></div>
          </div>
        </div>
      );
    }

    if (adminAccess === false) {
      return <Error403 />;
    }
    return (
      <>
        <Suspense fallback={
          <div id="preloader">
            <div className="sk-three-bounce">
              <div className="sk-child sk-bounce1"></div>
              <div className="sk-child sk-bounce2"></div>
              <div className="sk-child sk-bounce3"></div>
            </div>
          </div>
        }
        >
          <div
            id={"main-wrapper"}
            className={"show"}
          >
            <Nav />
            <div className={"content-body"}>
              <div
                className={"container-fluid"}
                style={{ minHeight: window.screen.height - 60, padding: "15px", maxWidth: "1400px", margin: "0 auto" }}
              >
                <Routes>
                  <Route path="/" element={<SuperAdminHome />} />
                  <Route path="/dashboard" element={<SuperAdminHome />} />
                  <Route path="/users-management" element={<Navigate to="/users-management/list" replace />} />
                  <Route path="/users-management/list" element={<UsersListPage />} />
                  <Route path="/users-management/active" element={<UsersActivePage />} />
                  <Route path="/users-management/create" element={<UsersCreatePage />} />
                  <Route path="/users-management/edit" element={<UsersEditPage />} />
                  <Route path="/users-management/assign-business" element={<UsersAssignBusinessPage />} />
                  <Route path="/demo-management" element={<DemoManagement />} />
                  <Route path="/demo-requests" element={<DemoRequestsPage />} />
                  <Route path="/demo-management/assign" element={<UsersDemoPage />} />
                  <Route path="/users-management/demo" element={<UsersDemoPage />} />
                  <Route path="/beetinq-team" element={<BeetinqTeamManagementPage />} />
                  <Route path="/business-management" element={<BusinessManagement />} />
                  <Route path="/business-management/list" element={<BusinessListPage />} />
                  <Route path="/business-management/active" element={<BusinessActivePage />} />
                  <Route path="/business-management/create" element={<BusinessCreatePage />} />
                  <Route path="/business-management/edit" element={<BusinessEditPage />} />
                  <Route path="/business-management/assign-users" element={<BusinessAssignUsersPage />} />
                  <Route path="/digital-cards" element={<DigitalCardsManagement />} />
                  <Route path="/digital-cards/list" element={<DigitalCardsListPage />} />
                  <Route path="/digital-cards/active" element={<DigitalCardsActivePage />} />
                  <Route path="/digital-cards/create" element={<DigitalCardsCreatePage />} />
                  <Route path="/digital-cards/edit" element={<DigitalCardsEditPage />} />
                  <Route path="/meeting-statistics" element={<MeetingStatisticsPage />} />
                  <Route path="/statistics" element={<StatisticsDashboardPage />} />
                  <Route path="*" element={<SuperAdminHome />} />
                </Routes>
              </div>
            </div >
            <Footer />
          </div >
          <ScrollToTop />
        </Suspense>
      </>
    );
  }

  return (
    <>
      <Routes>
        <Route path="/login" element={<LoginEmail />} />
        <Route path="*" element={<LoginEmail />} />
      </Routes>
    </>
  );
}

export default App;
